export default "__VITE_ASSET__Dl5KLzXB__"